import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import api from "axios";
import Lottie from "lottie-react-web";
import { Link } from "react-router-dom";
import styled from "styled-components";
import success from "~/animations/success.json";
import ContainedButton from "~/components/layout/form/containedButton";
import { IoMdArrowForward } from "react-icons/io";
import { scanHeaders } from "~/services/scanHeaders";

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  max-width: 400px;
  height: auto;
`;

const SuccessIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 45px;
  height: 45px;
  border: 5px solid #0ecb00;
  border-radius: 50%;
  color: #0ecb00;

  margin-right: 15px;
`;

const SuccessTitle = styled.span`
  font-size: 1.3rem;
  font-weight: 700;
  text-align: left;
  color: #005ca5;
`;

const SuccessText = styled.span`
  color: #808495;
  text-align: left;
  margin-top: 10px;
  font-size: 0.95rem;
  @media (max-width: 370px) {
    font-size: 1rem;
    padding: 0;
  }
`;

const UacDescription = styled.span`
  font-size: 1.1rem;
  color: #4d565c;
`;

const OpeningHoursContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const IconContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  margin: 30px 0;
`;

class Steps extends Component {
  componentDidMount() {
    // this.sendValidationToken();
  }

  sendValidationToken = () => {
    const { contactName, contactId, url } = this.props;
    const header = {
      "Content-Type": "application/json",
      ...scanHeaders
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      tokenType: 'REGISTER',
      url: process.env.REACT_APP_REGISTER_URL_CONFIRMATION,
      contactId,
    };
    api
      .post(`${url}/tokens`, body, parameters)
      .then((res) => {
        return null;
      })
      .catch((err) => {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  render() {
    return (
      <SuccessContainer>
        <SuccessTitle>Tudo certo!!</SuccessTitle>
        <SuccessText>{this.props.contactName}</SuccessText>
        <SuccessText>
          Agora você pode acessar o portal para gerenciar o gás do seu negócio,
          na hora que quiser e aonde estiver
        </SuccessText>
        <IconContainer>
          <SuccessIconContainer>
            <div className="mdi mdi-check mdi-24px" />
          </SuccessIconContainer>
          <UacDescription>
            Foi Enviado um e-mail para acesso ao link de confirmação de seu novo
            cadastro, valido por 1 hora.
          </UacDescription>
        </IconContainer>
        <Link to="/" style={{ textDecoration: 'none', width: '100%' }}>
          <ContainedButton
            block
            continue
            type="submit"
            icon="arrow-right"
            text="Acesse o Portal"
            color="#4ec937"
            name="acessar"
            id="acessar"
            width="100%"
            TrailingIcon={() => <IoMdArrowForward size={20} />}
          >
            Acesse o Portal
          </ContainedButton>
        </Link>
      </SuccessContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  contactName: state.signUpReducer.contactName,
  contactId: state.signUpReducer.contactId,
  url: state.signUpReducer.url,
});

export default connect(mapStateToProps)(Steps);
